module.exports = __webpack_public_path__ + "img/decorative-line-one-side-flourish-only-small.0a82f225.svg";